/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@/utils/format';

export const state = {
  instrumen: null,
};

export const mutations = {
  SET_INSTRUMEN(state, newValue) {
    state.instrumen = newValue;
  },
};

export const actions = {
  async fetch({}, payload) {
    return await http.get(`/psp/gtk/pendampingan-lokakarya?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async getDetail({}, payload) {
    return await http
      .get(`/psp/gtk/pendampingan-lokakarya/${payload.id}/kegiatan/${payload.kKegiatan}`)
      .then(({ data }) => data);
  },

  async getInstrumen({ commit }, payload) {
    const instrumen = await http
      .get(`/psp/gtk/pendampingan-lokakarya/instrumen?master=${payload.masters}`)
      .then(({ data }) => data);

    commit('SET_INSTRUMEN', instrumen);

    return instrumen;
  },

  async sekolah({}, payload) {
    return await http
      .get(`/psp/gtk/pendampingan-lokakarya/${payload.id}/sekolah?${queryString(payload.params)}`)
      .then(({ data }) => data);
  },

  update({}, payload) {
    return http.post(`/psp/gtk/pendampingan-lokakarya/${payload.id}/update`, payload.params).then(({ data }) => data);
  },

  updateNyata({}, payload) {
    return http
      .post(`/psp/gtk/pendampingan-lokakarya/${payload.id}/update-nyata`, payload.params)
      .then(({ data }) => data);
  },

  upload({}, payload) {
    let url = `/psp/gtk/pendampingan-lokakarya/${payload.pspKpPaId}/berkas/insert`;
    if (payload.berkasId) {
      url = `/psp/gtk/pendampingan-lokakarya/${payload.pspKpPaId}/berkas/${payload.berkasId}/reupload`;
    }

    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  delete({}, payload) {
    return http.post(`/psp/gtk/pendampingan-lokakarya/${payload.pspKpPaId}/berkas/${payload.id}/delete`);
  },

  cekRekaman({}, payload) {
    return http.get(`/psp/gtk/kp-lokakarya/cek-rekaman?${queryString(payload)}`).then(({ data }) => data);
  },
};
